import clsx from 'clsx';
import { useGlobalInfo, TOGGLE_ACTIVE_MENU_GROUP } from '@/utils/hooks/context/useGlobalInfo';

import { SwitchWithIcons } from '@/components/base/Switch/SwitchWithIcons';
import type { SwitchWithIconsProps } from '@/components/base/Switch/SwitchWithIcons';
import Icon from '@/components/base/Icon';

type IconProps = { enabled: boolean; size?: string };

function getLeftIcon({ enabled, size = 'text-xxs' }: IconProps) {
    return (
        <Icon
            icon="single-profile"
            className={clsx('transition-colors', size, {
                'text-icoBlue': enabled,
                'text-white': !enabled
            })}
        />
    );
}

export function getRightIcon({ enabled, size = 'text-xxs' }: IconProps) {
    return (
        <Icon
            icon="group"
            className={clsx('transition-colors', size, {
                'text-icoBlue': !enabled,
                'text-white': enabled
            })}
        />
    );
}

type SwitchRightMenuProps = {
    size?: SwitchWithIconsProps['size'];
    iconSize?: string;
};
export function SwitchRightMenu({ size, iconSize }: SwitchRightMenuProps) {
    const { dispatch, globalInfo } = useGlobalInfo();

    return (
        <SwitchWithIcons
            data-testid="switch-right-menu"
            enabled={globalInfo.menuGroupActive}
            setEnabled={(enabled) => dispatch({ type: TOGGLE_ACTIVE_MENU_GROUP, payload: enabled })}
            size={size}
            className="pendo-group-social-profile-switch bg-white dark:bg-icoDarkMode-deepBlack"
            dotClassName="bg-icoBlue"
            leftIcon={({ enabled }) => getLeftIcon({ enabled, size: iconSize })}
            rightIcon={({ enabled }) => getRightIcon({ enabled, size: iconSize })}
        />
    );
}
